import { AppointmentInterface } from '../types/appointment';

export const convertAppointmentFromApi = (apiAppointment: any) => {
    const appointment: AppointmentInterface = {
        id: apiAppointment.id,
        stockNumber: apiAppointment.stock.stockNumber,
        reference: apiAppointment.reference,
        remarks: apiAppointment.remarks,
        state: convertState(apiAppointment.state),
        rawState: apiAppointment.state,
        deliveryDate: apiAppointment.deliveryDate,
        desiredDeliveryDate: apiAppointment.desiredDeliveryDate,
        tasks: apiAppointment.tasks,
        deliveryMethod: apiAppointment.deliveryMethod,
        pickUpLocation: apiAppointment.pickUpLocation,
    };

    return appointment;
};

const convertState = (state: null | string) => {
    switch (state) {
        case 'open':
            return 'Afspraak gemaakt';
        case 'in_progress':
            return 'In behandeling';
        case 'to_pick_up':
            return 'Kan opgehaald worden';
        default:
            return null;
    }
};

export const canUpdateAppointment = (
    appointment: AppointmentInterface | null
) => {
    if (!appointment) {
        return false;
    }

    return appointment.rawState === 'open';
};

export const canCreateAppointment = (
    appointment: AppointmentInterface | null
) => {
    if (!appointment) {
        return true;
    }

    return !['in_progress', 'open'].includes(appointment.rawState);
};
